import { barcodeScannerReducer as barcodeScanner } from 'react-usb-barcode-scanner';

export default {
  barcodeScanner,
}

